import { Component, Injector,EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ProfileServiceProxy } from '@shared/service-proxies/service-proxies';
import { IAjaxResponse, TokenService } from '@node_modules/abp-ng2-module';
import { AppConsts } from '@shared/AppConsts';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
// import { CKFinder } from 'ckeditor5';
@Component({
    selector: 'file-upload-ckfinder',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadCkfinderComponent extends AppComponentBase implements OnInit {
    @Input() data: string;
    @Input() isAllowEdit: boolean;
    @Output() dataChange = new EventEmitter();

  constructor(injector: Injector, private _tokenService: TokenService, private _httpClient: HttpClient,) {
      super(injector);
  }




  ngOnInit() {
  }
  setPathNull(){
    this.data = '';
    this.dataChange.emit(this.data);
  }
  openCkfinder(){

    var token = this._tokenService.getToken();
    var baseCkfinderUrl =AppConsts.ckfinderBaseUrl;
    window["CKFinder"].config({
         language: 'vi',
         connectorInfo:"token="+token,
         connectorPath:baseCkfinderUrl+'/ckfinder/connector',
         filebrowserBrowseUrl : baseCkfinderUrl+'/ckfinder/ckfinder.html',
         filebrowserImageBrowseUrl : baseCkfinderUrl+'/ckfinder/ckfinder.html?type=Images',
         filebrowserFlashBrowseUrl : baseCkfinderUrl+'/ckfinder/ckfinder.html?type=Flash',
         filebrowserUploadUrl : baseCkfinderUrl+'/ckfinder/connector?command=QuickUpload&type=Files',
         filebrowserImageUploadUrl : baseCkfinderUrl+'/ckfinder/connector?command=QuickUpload&type=Images',
         filebrowserFlashUploadUrl : baseCkfinderUrl+'/ckfinder/connector?command=QuickUpload&type=Flash'
     });




    let that=this;
    let config = {
        language:'',
        chooseFiles: true,
        chooseFilesOnDblClick :true,
        onInit: function( finder ) {
            finder.on( 'files:choose', function( evt ) {
                var file = evt.data.files.first();
                that.data = file.getUrl();
                that.dataChange.emit(that.data);
            } );
            finder.on( 'file:choose:resizedImage', function( evt ) {

                that.data = evt.data.resizedUrl;
                that.dataChange.emit(that.data);
            } );
        }
    };
    window["CKFinder"].modal(config);






  }
  

  
}